import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// Custom components
import useB2GApiGet from 'hooks/v1/main/useB2GApiGet';
import DataTable from "components/v1/main/structure/Table";
import { useContext, useEffect, useState } from "react";

// Context variables
import { APIHandlerContext } from 'GlobalContextProviders';
import Button from "components/v1/main/form/Button";
import FieldSet from "components/v1/main/structure/FieldSet";
import RenderHtml from "components/v1/main/structure/RenderHtml";
import { FilterMatchMode } from "primereact/api";
import { consoleLog } from "functions/v1/main/utilitiesFunctions";

const OutreachPublicList = () => {

    const contentId = 1403;
    const filterDefaults = { // This is the set of things we're filtering. We can set the filter type too.
        subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
    }

    // React hooks
    const navigate = useNavigate();
    const location = useLocation();

    // Page specific state variables
    const [lazyState, setLazyState] = useState<any>({ // Lazy loading
        filters: filterDefaults
    }); 
    const [loading, setLoading] = useState(true); // Lazy loading
    const [data, setData] = useState<any>([]);
    const [showDueDate, setShowDueDate] = useState(false); 

    // Get necessary data from location
    let [queryStringParams] = useSearchParams();    
    let orgShortName: string | null = "";
      // Get necessary data from location
    if (location.state !== null)
        orgShortName = location.state.orgShortName;
    else
        orgShortName = queryStringParams?.get("TN");    

    const viewButtonTemplate = (rowData: any) => {
        return (
          <span data-fieldname="outreachID">
            { <Button label="View" type="default-blue" size='small' onClick={() => navigateToOutreach(rowData.outreachID)}/>}
          </span>
        );
    };

    const dateDueBodyTemplate = (rowData : any) => {
        return (
          <span data-fieldname="noticeDate">
            { rowData.noticeDate &&
              new Date(rowData.noticeDate).toLocaleDateString('en-US')
            }
          </span>
        );
    };

    const dateResponseDueBodyTemplate = (rowData : any) => {

        if(rowData.responseDueDate != null) {
            return (
                <span data-fieldname="responseDueDate">
                  { rowData.noticeDate &&
                    new Date(rowData.responseDueDate).toLocaleDateString('en-US')
                  }
                </span>
              );
        }
        else {
            return (
                <span data-fieldname="responseDueDate">
                  N/A
                </span>
              ); 
            }
    };
    
    // Event handlers
    const navigateToOutreach = (outreachID : string) => {
        navigate("/outreach/public/view",  { state: { outreachID: outreachID, orgShortName: orgShortName  } });
    } 

    // Get data
    const b2gAPI = useContext(APIHandlerContext);

    const { data: contentData } = useB2GApiGet(
        `/system/webpages/${contentId}/public?templateName=${orgShortName}`
    );

    useEffect(() => {
        setLoading(true);

        let url = "/outreachcampaigns/listings/" + orgShortName;
        if (lazyState.filters.subject.value != null) {
            url += "?subjectFilter=" + lazyState.filters.subject.value;
        }

        b2gAPI.get(url, function(response){
            //consoleLog("Api Data...");
            //consoleLog(response.data);
            if (response.data.response.length > 0) {
              // Handle all the page updates
              setData(response.data);
              setShowDueDate(response.data.response[0].outreachResponse);
            }
            else {
              setData([]);
            }
            setLoading(false);
          });
    }, [b2gAPI, lazyState]);

    const onFilter = (event : any) => {
        setLazyState(event);
    };

    return (
        <>
            {contentData?.response && contentData.response.length > 0 ? (
                <RenderHtml html={contentData.response[0].content} />
            ) : (
                <div className="text-center">
                    <h2>Outreach List</h2>
                </div>
            )}

            <FieldSet legend='Active Listings' className='mb-3'>
                {data &&
                <DataTable.Single
                    value={data.response} 
                    emptyMessage="No listings are currently active. Please check back later."
                    /* Filter stuff */
                    filters={lazyState.filters}
                    filterDisplay="row"
                    /* Lazy Loading Stuff */
                    lazy
                    loading={loading}
                    onFilter={onFilter}
                >
                    <DataTable.Column 
                        field="subject" 
                        header="Subject"
                        style={{ minWidth: '15rem' }}
                        /* Filter Stuff */
                        filter 
                        showFilterMenu={false}
                        filterPlaceHolder="Search by name"
                    />
                    <DataTable.Column 
                        field="noticeDate" 
                        header="Date Posted"
                        style={{ minWidth: '10rem' }}
                        body={dateDueBodyTemplate}
                    />
                    {showDueDate &&
                    <DataTable.Column 
                        field="responseDueDate" 
                        header="Due Date"
                        style={{ minWidth: '10rem' }}
                        body={dateResponseDueBodyTemplate} 
                    />  
                    }               
                    <DataTable.Column 
                        header="View"
                        field="outreachID" 
                        body={viewButtonTemplate}
                        style={{ minWidth: '5rem' }}
                    />
                </DataTable.Single>
                }
            </FieldSet>
        </>
    );
}

export default OutreachPublicList;